// Custom Tolstoy JS

document.addEventListener('DOMContentLoaded', () => {

  initProductSliders();

  // ── DOM refs ───────────────────────────────────────────────

  const popup = document.getElementById('tolstoy-popup');
  if (!popup) return;

  const reel          = popup.querySelector('.tolstoy-reel');
  const popupVideoBox = popup.querySelector('.tolstoy-popup__video');
  const popupProduct  = popup.querySelector('.tolstoy-popup__product');
  const progressBar   = popup.querySelector('.tolstoy-progress-bar');
  const closeBtn      = popup.querySelector('.tolstoy-popup__close');
  const nextBtn       = popup.querySelector('.popup-item__next');
  const prevBtn       = popup.querySelector('.popup-item__prev');
  const pauseIcon     = popup.querySelector('.pause-state__icon');
  const muteBtn       = popup.querySelector('.video-mute');

  const videos = Array.from(
    document.querySelectorAll('.product__shopable_media .tolstoy-thumb__video')
  );

  // ── State ──────────────────────────────────────────────────

  let currentVideoIndex = 0;
  let isAnimating       = false;
  let popupOpen         = false;
  let isMuted           = false;
  let progressRafId     = null;
  let touchStartY       = 0;

  // ── Progress bar ───────────────────────────────────────────

  function startProgress() {
    if (progressRafId) cancelAnimationFrame(progressRafId);
    progressBar.style.width = '0%';

    function tick() {
      const video = getActiveVideo();
      if (video && video.duration) {
        progressBar.style.width = (video.currentTime / video.duration * 100) + '%';
      }
      progressRafId = requestAnimationFrame(tick);
    }

    progressRafId = requestAnimationFrame(tick);
  }

  function stopProgress() {
    if (progressRafId) cancelAnimationFrame(progressRafId);
    progressRafId           = null;
    progressBar.style.width = '0%';
  }

  // ── Helpers ────────────────────────────────────────────────

  function wrapIndex(i) {
    return (i + videos.length) % videos.length;
  }

  function getActiveVideo() {
    const current = reel.querySelector('[data-pos="0"]');
    return current ? current.querySelector('video') : null;
  }

  // ── Product cache ──────────────────────────────────────────

  const productCache = new Map();

  async function preloadProduct(handle) {
    if (!handle || productCache.has(handle)) return;
    try {
      const res = await fetch(`/products/${handle}?view=tolstoy-product`);
      productCache.set(handle, await res.text());
    } catch {
      productCache.set(handle, '<p>Product not found</p>');
    }
  }

  async function loadPopupProduct(handle) {
    if (!handle) return;

    if (productCache.has(handle)) {
      popupProduct.innerHTML = productCache.get(handle);
      return;
    }

    popupProduct.innerHTML = '<div class="tolstoy-loading">Loading...</div>';
    try {
      const res  = await fetch(`/products/${handle}?view=tolstoy-product`);
      const html = await res.text();
      productCache.set(handle, html);
      popupProduct.innerHTML = html;
    } catch {
      popupProduct.innerHTML = '<p>Product not found</p>';
    }
  }

  // ── Reel items ─────────────────────────────────────────────

  function createReelItem(videoIndex, position) {
    const source  = videos[videoIndex];
    const wrapper = document.createElement('div');
    wrapper.className     = 'tolstoy-reel-item';
    wrapper.dataset.index = videoIndex;
    wrapper.dataset.pos   = position;

    const clone = source.cloneNode(true);
    clone.removeAttribute('controls');
    clone.autoplay = false;
    clone.loop     = true;
    clone.muted    = true;
    clone.volume   = 1;

    wrapper.appendChild(clone);
    return wrapper;
  }

  // ── Reel build ─────────────────────────────────────────────

  function buildReel(index) {
    reel.innerHTML = '';

    [
      { pos: -1, vidIndex: wrapIndex(index - 1) },
      { pos:  0, vidIndex: index                },
      { pos:  1, vidIndex: wrapIndex(index + 1) },
    ].forEach(({ pos, vidIndex }) => {
      reel.appendChild(createReelItem(vidIndex, pos));
    });

    currentVideoIndex = index;

    [wrapIndex(index - 1), index, wrapIndex(index + 1)].forEach(i => {
      preloadProduct(videos[i].dataset.product);
    });

    playCurrentVideo();
  }

  // ── Playback ───────────────────────────────────────────────

  function playCurrentVideo() {
    reel.querySelectorAll('video').forEach(v => {
      v.pause();
      v.currentTime = 0;
    });

    const video = getActiveVideo();
    if (!video) return;

    video.muted  = isMuted;
    video.volume = 1;
    video.play().catch(() => {});
    video.classList.remove('paused');
    pauseIcon.classList.remove('active');

    loadPopupProduct(video.dataset.product);
    startProgress();
  }

  function toggleVideo() {
    const video = getActiveVideo();
    if (!video) return;

    if (video.paused) {
      video.play().catch(() => {});
      video.classList.remove('paused');
      pauseIcon.classList.remove('active');
    } else {
      video.pause();
      video.classList.add('paused');
      pauseIcon.classList.add('active');
    }
  }

  // ── Navigation ─────────────────────────────────────────────

  async function changeVideo(direction) {
    if (isAnimating) return;

    const nextIndex = wrapIndex(currentVideoIndex + direction);
    isAnimating = true;

    const currentItems = Array.from(reel.querySelectorAll('.tolstoy-reel-item'));
    currentItems.forEach(item => item.classList.add('animating'));
    currentItems.forEach(item => {
      item.dataset.pos = Number(item.dataset.pos) - direction;
    });

    await new Promise(r => setTimeout(r, 420));

    const outPos  = direction === 1 ? -2 : 2;
    const outItem = reel.querySelector(`[data-pos="${outPos}"]`);
    if (outItem) outItem.remove();

    const inPos      = direction === 1 ? 1 : -1;
    const inVidIndex = wrapIndex(nextIndex + direction);
    reel.appendChild(createReelItem(inVidIndex, inPos));
    preloadProduct(videos[inVidIndex].dataset.product);

    reel.querySelectorAll('.tolstoy-reel-item').forEach(item => {
      item.classList.remove('animating');
    });

    currentVideoIndex = nextIndex;
    isAnimating       = false;

    playCurrentVideo();
  }

  // ── Popup open / close ─────────────────────────────────────

  function openPopup(video) {
    const index = videos.indexOf(video);
    if (index === -1) return;

    popupOpen = true;
    popup.classList.remove('hidden');
    if (muteBtn) muteBtn.classList.toggle('is-muted', isMuted);

    buildReel(index);
  }

  document.querySelectorAll('.tolstoy-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const video = thumb.querySelector('.tolstoy-thumb__video');
      if (video) openPopup(video);
    });
  });

  closeBtn.addEventListener('click', e => {
    e.stopPropagation();
    stopProgress();
    popupOpen              = false;
    popup.classList.add('hidden');
    reel.innerHTML         = '';
    popupProduct.innerHTML = '';
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeBtn.click();
  });

  // ── Prev / Next buttons ────────────────────────────────────

  nextBtn.addEventListener('click', e => { e.stopPropagation(); changeVideo(1);  });
  prevBtn.addEventListener('click', e => { e.stopPropagation(); changeVideo(-1); });

  // ── Mouse wheel / trackpad scroll ─────────────────────────

  popupVideoBox.addEventListener('wheel', e => {
    e.preventDefault();
    if (isAnimating) return;
    changeVideo(e.deltaY > 0 ? 1 : -1);
  }, { passive: false });

  // ── Touch swipe ────────────────────────────────────────────

  popupVideoBox.addEventListener('touchstart', e => {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  popupVideoBox.addEventListener('touchend', e => {
    const diff = touchStartY - e.changedTouches[0].clientY;
    if (Math.abs(diff) < 50) return;
    changeVideo(diff > 0 ? 1 : -1);
  }, { passive: true });

  // ── Play / Pause toggle ────────────────────────────────────

  pauseIcon.addEventListener('click', e => { e.stopPropagation(); toggleVideo(); });

  popupVideoBox.addEventListener('click', e => {
    if (e.target.closest('.video-mute'))        return;
    if (e.target.closest('.pause-state__icon')) return;
    toggleVideo();
  });

  // ── Mute / Unmute ──────────────────────────────────────────

popup.addEventListener('click', e => {

  const button = e.target.closest('.video-mute');

  if (!button) return;


  e.stopPropagation();


  const video = getActiveVideo();

  if (!video) return;



  isMuted = !isMuted;


  video.muted = isMuted;



  button.classList.toggle(
    'is-muted',
    isMuted
  );


  // FIX: remove pause state when mute button starts video

  if(video.paused){

    video.play().catch(()=>{});

  }


  video.classList.remove('paused');


  if(pauseIcon){

    pauseIcon.classList.remove('active');

  }

});

  // ── Add to Cart ────────────────────────────────────────────

  popupProduct.addEventListener('click', async e => {
    const btn = e.target.closest('[data-tolstoy-atc]');
    if (!btn) return;
    e.preventDefault();

    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled    = true;
    btn.textContent = 'Adding...';

    try {
      await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ id: Number(variantId), quantity: 1 }),
      });

      btn.textContent = 'Added!';
      setTimeout(() => {
        btn.disabled    = false;
        btn.textContent = 'Add to Cart';
      }, 1500);

            if (window.cart && typeof window.cart.openCartDrawer === 'function') {
        window.cart.getCart();
        window.cart.openCartDrawer();
      }

      closeBtn.click();

    } catch {
      btn.disabled    = false;
      btn.textContent = 'Add to Cart';
    }
  });

  // ── Thumbnail auto-play sequence (popup closed) ────────────

  async function playSequence() {
    if (!videos.length) return;
    let index = 0;

    while (true) {
      if (popupOpen) {
        await new Promise(r => setTimeout(r, 500));
        continue;
      }

      const video = videos[index];
      videos.forEach(v => v.pause());
      video.muted = true;
      video.play().catch(() => {});

      await new Promise(r => setTimeout(r, 5000));
      video.pause();

      index = (index + 1) % videos.length;
    }
  }

  playSequence();

});

// ── Flickity slider init ────────────────────────────────────────

function initProductSliders() {

  document.querySelectorAll('.product__shopable_media').forEach(slider => {

    const isDesktopSlider = slider.classList.contains('desktop-slider');
    const isMobileSlider = slider.classList.contains('mobile-slider');

    const enableSlider =
      (window.innerWidth > 1200 && isDesktopSlider) ||
      (window.innerWidth <= 1200 && isMobileSlider);


    if (!enableSlider) {
      return;
    }


    new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      wrapAround: false,
      freeScroll: true
    });


  });

}



////////////////// UGC FEED

document.addEventListener('DOMContentLoaded', function () {

  var slider = document.querySelector('.product__tolstoy-carousel');

  if (!slider) return;

  var wrapper = document.querySelector('.custom-tolstoy-carousel');

  if (!wrapper) return;

  var arrows = wrapper.querySelector('.prev-next--icons');

  // Count slides
  var slides = slider.querySelectorAll('.video');

  // Hide arrows & don't initialize Flickity if 2 or fewer slides
  if (slides.length <= 2) {

    if (arrows) {
      arrows.style.display = 'none';
    }

    return;
  }

  var isMobile = window.innerWidth <= 768;

  var flkty = new Flickity(slider, {
    cellAlign: 'left',
    wrapAround: true,
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    groupCells: isMobile ? 1 : 2,
    autoPlay: isMobile ? false : 12000
  });

  var prevBtn = wrapper.querySelector('.prv-arrow');
  var nextBtn = wrapper.querySelector('.next-arrow');

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      flkty.previous();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      flkty.next();
    });
  }

  // Mobile only video mute/unmute
  if (isMobile) {

    var videos = slider.querySelectorAll('video');

    videos.forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
    });

    var muteButtons = slider.querySelectorAll('.video-mute');

    muteButtons.forEach(function (button) {

      button.addEventListener('click', function (e) {

        e.stopPropagation();

        var video = button.closest('.video-wrap').querySelector('video');

        if (!video) return;

        if (video.muted) {
          video.muted = false;
          button.classList.remove('is-muted');
          button.classList.add('is-unmuted');
        } else {
          video.muted = true;
          button.classList.remove('is-unmuted');
          button.classList.add('is-muted');
        }

      });

    });

  }

});